import { useEffect } from 'react';
import { useQueryData } from './useQueryData';
import { useState } from 'react';
// @ts-expect-error - JS file
import { disableHubSpotCookieBanner } from '../utils/disableHubSpotCookieBanner';
import { setLoginMetadataCookieEnableAll } from '../utils/cookies';
import Raven from 'raven-js';
import { useLocation } from 'quartz-routing/react-router';
import { setReauthCookie } from '../data/MobileReauthApi';
export const useMobileReauthCookie = () => {
  const [isMobileLogin, setIsMobileLogin] = useState(true);
  const {
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const reauthParam = searchParams.get('reauth');
  if (reauthParam) {
    Raven.captureMessage('Reauth query param', {
      extra: {
        reauthParam
      }
    });
  }
  const {
    allQueryParams
  } = useQueryData();
  const reauth = allQueryParams.reauth;
  useEffect(() => {
    const setReauthCookieFromQueryParam = async () => {
      if (reauth) {
        const reauthCookie = Array.isArray(reauth) ? reauth[0] : reauth;
        await setReauthCookie(reauthCookie);
        setLoginMetadataCookieEnableAll();
        disableHubSpotCookieBanner();
        setIsMobileLogin(true);
      } else {
        setIsMobileLogin(false);
      }
    };
    void setReauthCookieFromQueryParam();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isMobileLogin;
};